import {Box, Button, ButtonBase, Container, Divider, Grid, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import {CreditCard} from '@mui/icons-material';

export const PaymentMainSection = styled(Box)(() => ({
  backgroundColor: '#fff'
}));

export const PaymentContainer = styled(Container)(() => ({
  '&&': { // trick to increase specificity to override the global style: .MuiContainer-maxWidthLg from index.css
    maxWidth: '97.14em !important',
    margin: '0 auto',
  }
}));

export const PaymentSection = styled(Box)(() => ({
  padding: '2em 0em',
}));

export const PaymentHeading = styled(Typography)(() => ({
  fontSize: '1.43em',
  fontWeight: '600',
  fontFamily: 'Inter',
  lineHeight: '2.28em',
  letterSpacing: '0.01em',
}));

export const PaymentLpDivider = styled(Divider)(() => ({
  height: '0.07rem',
  color: '#EEEEEE',
  marginTop: '1em',
}));

export const PaymentMainContainer = styled(Grid)(() => ({
  columnGap: '2.3em',
  marginTop: '2em',
  marginBottom: '8em',
}));

export const PaymentLpListingInfoSection = styled(Grid)(({theme}) => ({
  [theme.breakpoints.between('md', 'lg')]: {
    width: '57.14rem',
  }
}));

export const PaymentButton = styled(Button)(() => ({
  fontFamily: 'Inter',
  fontSize: '0.9em',
  fontWeight: '500',
  lineHeight: '1.57em',
  letterSpacing: '0.03em',
}));

export const PaymentPayIcon = styled(CreditCard)(() => ({
  marginRight: '0.3em',
}));

export const PaymentSaveInfoContainer = styled(Box)(({theme}) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '0.5em',
  marginTop: '1.5em',
  marginBottom: '1.5em',
}));

export const PaymentNoPayment = styled(Typography)(() => ({
  fontWeight: '500',
  lineHeight: '1.71em',
  fontFamily: 'Inter',
  color: 'rgba(0, 0, 0, 0.87)',
  marginBottom: '2em',
  marginTop: '2em',
  fontSize: '1.71em',
  textAlign: 'center'
}));

export const PaymentBookCardContainer = styled(ButtonBase)(({theme}) => ({
  padding: '1.43em',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  width: '100%',
}));

export const PaymentGap = styled(Grid)(() => ({
  gap: '0.5em'
}));

export const PaymentCardImg = styled('img')(() => ({
  width: '3.42em',
  height: '2.28em',
  objectfit: 'cover'
}));

export const PaymentCardTitle = styled(Typography)(() => ({
  fontSize: '1.14em',
  lineHeight: '1.71em',
  fontWeight: '500',
  fontFamily: 'Inter'
}));

export const PaymentCircle = styled(Box)(({theme}) => ({
  width: '1.14em',
  height: '1.14em',
  borderRadius: '50%',
  border: `2px solid ${theme.palette.primary.main}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
}));

export const PaymentCircleInner = styled(Box)(({theme}) => ({
  width: '0.57em',
  height: '0.57em',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
}));
